import React from 'react';
import { io, Socket } from 'socket.io-client';

// "undefined" means the URL will be computed from the `window.location` object

let URL;

let path;

if (process.env.REACT_APP_ENVIROMENT === 'Production') {
	path = '/swarmob-nest-backend/prod/socket.io';
	URL = 'https://swarmob.cloud';
} else if (process.env.REACT_APP_ENVIROMENT === 'staging') {
	path = '/swarmob-nest-backend/staging/socket.io';
	URL = 'https://swarmob.cloud';
} else {
	path = '/socket.io';
	URL = 'http://localhost:3002';
}

export const socket = io(URL || '', {
	path,
	transports: ['websocket', 'polling'],
	// settings
	reconnection: true, // Habilita auto-reconexión
	reconnectionAttempts: 5, // 5 intentos máximo
	reconnectionDelay: 1000, // 1 segundo inicial
	reconnectionDelayMax: 10000, // Máximo 10 segundos
	timeout: 10000, // 20 segundos timeout
	forceNew: false, // Reutilizar conexión
	autoConnect: true // Conectar automáticamente
});

export const SocketContext = React.createContext<Socket>(socket);
